import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import LeadSearchRegularAi from './lead-search-regular-ai-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <LeadSearchRegularAi {...validProps} />;
}
SvgComponent.iconName = 'leadSearchRegularAi';

export const LeadSearchRegularAiIcon = svgIconWrapper(SvgComponent);
